/* Elavate landing page behaviours.
   Swiper configs, tab + accordion logic ported verbatim from the source theme. */
(function () {
  'use strict';

  var unlikeSlider, premiumSlider, reviewSlider;

  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    if (document.querySelector('.unlike-any-other .unlike-slider')) {
      if (unlikeSlider) unlikeSlider.destroy(true, true);
      unlikeSlider = new Swiper('.unlike-any-other .unlike-slider', {
        slidesPerView: 1.5, slidesPerGroup: 1, initialSlide: 1,
        centeredSlides: true, grabCursor: true, loop: true, spaceBetween: 16,
        breakpoints: { 750: { slidesPerView: 3, grabCursor: false, loop: false, centeredSlides: false } },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
      });
    }

    if (document.querySelector('.premium-ingredient .premium-ingredient-slider')) {
      if (premiumSlider) premiumSlider.destroy(true, true);
      premiumSlider = new Swiper('.premium-ingredient .premium-ingredient-slider', {
        slidesPerView: 1.2, slidesPerGroup: 1, centeredSlides: true, loop: true,
        grid: { rows: 1, fill: 'row' }, spaceBetween: 15,
        breakpoints: {
          750:  { slidesPerView: 2, grabCursor: false, spaceBetween: 24, centeredSlides: false, loop: false, grid: { rows: 3 } },
          1101: { slidesPerView: 3, grabCursor: false, spaceBetween: 24, centeredSlides: false, loop: false, grid: { rows: 3 } }
        }
      });
    }
  }

  function initReviewSlider() {
    if (typeof Swiper === 'undefined' || !document.querySelector('.review-tab-slider')) return;
    reviewSlider = new Swiper('.review-tab-slider', {
      slidesPerView: 1.1, grabCursor: true, spaceBetween: 30, centeredSlides: true, loop: true,
      breakpoints: {
        0:    { slidesPerView: 1.2, spaceBetween: 15 },
        750:  { slidesPerView: 1.2, spaceBetween: 15 },
        990:  { slidesPerView: 1.3 },
        1200: { slidesPerView: 1.5 },
        1400: { slidesPerView: 1.9 }
      },
      navigation: { nextEl: '.review-tab .swiper-button-next', prevEl: '.review-tab .swiper-button-prev' }
    });
  }

  /* Review tabs: click switches which .review-content-block is shown.
     Source defaults to the SECOND tab on load. */
  function initReviewTabs() {
    var tabs = document.querySelectorAll('.tab-bar-block');
    var blocks = document.querySelectorAll('.review-content-block');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        var title = this.getAttribute('data-tab-title');
        blocks.forEach(function (b) {
          b.style.display = b.getAttribute('data-tab-title') === title ? 'block' : 'none';
        });
        if (reviewSlider && reviewSlider.update) reviewSlider.update();
      });
    });
    tabs[1] ? tabs[1].click() : tabs[0].click();
  }

  /* Q&A accordion: one open at a time. */
  function initAccordion() {
    var items = document.querySelectorAll('.el-section [js-acc-item]');
    function close(item) {
      var c = item.querySelector('[js-acc-single-content]');
      item.classList.remove('active');
      if (c) c.style.maxHeight = null;
    }
    function open(item) {
      var c = item.querySelector('[js-acc-single-content]');
      item.classList.add('active');
      if (c) c.style.maxHeight = 'max-content';
    }
    items.forEach(function (item) {
      var trigger = item.querySelector('[js-acc-single-trigger]');
      var content = item.querySelector('[js-acc-single-content]');
      if (!trigger || !content) return;
      trigger.addEventListener('click', function () {
        if (content.style.maxHeight) { close(item); }
        else { items.forEach(close); open(item); }
      });
    });
    items.forEach(function (item) { if (item.classList.contains('active')) open(item); });
  }

  /* Scroll-in animation, mirroring the source's IntersectionObserver reveal. */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('.el-section .scroll-trigger');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('el-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('el-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* Ingredient popup: source binds .popup--button / .viewall-btn to open, .close to dismiss. */
  function initIngredientModal() {
    var modals = document.querySelectorAll(".el-section .ingredient-model");
    if (!modals.length) return;
    function open() {
      modals.forEach(function (m) { m.style.display = "block"; });
      document.body.classList.add("overflow-hidden");
    }
    function close() {
      modals.forEach(function (m) { m.style.display = "none"; });
      document.body.classList.remove("overflow-hidden");
    }
    document.querySelectorAll(".el-section .popup--button, .el-section .viewall-btn").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    document.querySelectorAll(".el-section .ingredient-model .close").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); close(); });
    });
    modals.forEach(function (m) {
      m.addEventListener("click", function (e) { if (e.target === m) close(); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  function boot() {
    initSwipers();
    initReviewSlider();
    initReviewTabs();
    initAccordion();
    initIngredientModal();
    initScrollAnimations();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSwipers, 300);
  });

  document.addEventListener('shopify:section:load', boot);
})();
